import React from "react";

import "./loader.css"

export const Spinner = () => {

  return (
    <div className="ex-loader" role="status" aria-live="polite">
      <span className="ex-loader-ring">
        <span className="ex-loader-core" />
      </span>
      <span className="ex-loader-label">Loading</span>
    </div>
  );
}

export default Spinner;
